/**
 * Copyright (C) 2022 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 */
import styled from 'styled-components';
import AppBar from '@mui/material/AppBar';
import StyledProps from '../../theme/AppThemeInterface';
import { breakpoints } from '../../../materialui_wrappers/utils/StyledComponentsBreakpoints';

const MENU_BUTTON_ICON_SIZE = 24;

const AppBarWrapper = styled(AppBar)`
  grid-area: header;
  background-color: ${({ theme }: StyledProps) => theme.secondaryBackgroundColor};
  box-shadow: none !important;
  padding: 0 1rem 0 1px;
  @media print {
    display: none;
  }
  transition: padding 100ms cubic-bezier(0.4, 0, 0.6, 1) 0ms;
  // The MuiPaper element of the side nav has a z-index of 1200, so this places the app bar above the side nav
  z-index: 1201;
  .preview__pill {
    height: 9px;
    margin-top: 5px;
    color: ${({ theme }: StyledProps) => theme.buttonSelectedColor};
    background-color: rgba(0, 236, 255, 0.25);
    font-size: 9px;
    line-height: 9px;
    font-family: ${({ theme }: StyledProps) => theme.appFontFamily};
    padding: 1.5px;
    margin-left: 4px;
    font-weight: bold;
  }

  @media print {
    background-color: white;
    position: static;
    padding: 0;
  }

  .appheader {
    display: flex;
    justify-content: space-between;
    min-height: ${({ theme }: StyledProps) => theme.appHeaderHeightSmall};
    max-height: ${({ theme }: StyledProps) => theme.appHeaderHeightSmall};

    @media only screen and (min-width: ${breakpoints.sm}px) {
      min-height: ${({ theme }: StyledProps) => theme.appHeaderHeightLarge};
      max-height: ${({ theme }: StyledProps) => theme.appHeaderHeightLarge};
    }

    .appheader__menubtn {
      flex: 0 1 auto;
      margin: 0 0 0 0;
      padding: calc((${({ theme }: StyledProps) => theme.appHeaderHeightSmall} - ${MENU_BUTTON_ICON_SIZE}px) / 2);
      @media only screen and (min-width: ${breakpoints.sm}px) {
        padding: calc((${({ theme }: StyledProps) => theme.appHeaderHeightLarge} - ${MENU_BUTTON_ICON_SIZE}px) / 2);
      }

      @media print {
        display: none;
      }
    }

    > h1 {
      font-family: ${({ theme }: StyledProps) => theme.viasatFontFamilyHeavy};
      flex: 0 1 auto;
      color: ${({ theme }: StyledProps) => theme.primaryTextColor};
      font-size: 20px;
      font-weight: 700;
      line-height: 26px;
      height: 26px;
      margin-left: 5px;

      @media print {
        color: black;
        margin-left: 0px;
      }

      #appheader__projecttitle {
        font-family: ${({ theme }: StyledProps) => theme.viasatFontFamilyBook};
        font-weight: 100;
        letter-spacing: 0.05rem;
      }
    }
  }
`;

export default AppBarWrapper;
